import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck } from 'lucide-react';
const COVER_IMAGE = 'https://cdn.magicpatterns.com/uploads/4K3DGajw8RBxZt9YF86Wxj/ChatGPT_Image_Feb_6,_2026,_05_01_10_PM.png';
const PURCHASES = [{
  name: 'Jessica M.',
  city: 'Bend',
  state: 'OR'
}, {
  name: 'David K.',
  city: 'Asheville',
  state: 'NC'
}, {
  name: 'Sarah T.',
  city: 'Bozeman',
  state: 'MT'
}, {
  name: 'Michael R.',
  city: 'Cedar Rapids',
  state: 'IA'
}, {
  name: 'Amanda L.',
  city: 'Savannah',
  state: 'GA'
}, {
  name: 'Chris W.',
  city: 'Flagstaff',
  state: 'AZ'
}, {
  name: 'Lauren P.',
  city: 'Burlington',
  state: 'VT'
}, {
  name: 'James H.',
  city: 'Duluth',
  state: 'MN'
}, {
  name: 'Emily S.',
  city: 'Chattanooga',
  state: 'TN'
}, {
  name: 'Ryan B.',
  city: 'Fort Collins',
  state: 'CO'
}, {
  name: 'Megan D.',
  city: 'Traverse City',
  state: 'MI'
}, {
  name: 'Andrew F.',
  city: 'Charlottesville',
  state: 'VA'
}, {
  name: 'Nicole G.',
  city: 'Santa Fe',
  state: 'NM'
}, {
  name: 'Brandon C.',
  city: 'Missoula',
  state: 'MT'
}, {
  name: 'Katie J.',
  city: 'Greenville',
  state: 'SC'
}, {
  name: 'Tyler N.',
  city: 'Spokane',
  state: 'WA'
}, {
  name: 'Rachel A.',
  city: 'Pensacola',
  state: 'FL'
}, {
  name: 'Daniel V.',
  city: 'Fargo',
  state: 'ND'
}, {
  name: 'Stephanie E.',
  city: 'Sedona',
  state: 'AZ'
}, {
  name: 'Kevin O.',
  city: 'Ithaca',
  state: 'NY'
}, {
  name: 'Ashley R.',
  city: 'Boise',
  state: 'ID'
}, {
  name: 'Marcus T.',
  city: 'Roanoke',
  state: 'VA'
}, {
  name: 'Heather W.',
  city: 'Sioux Falls',
  state: 'SD'
}, {
  name: 'Jason L.',
  city: 'Eureka',
  state: 'CA'
}, {
  name: 'Brittany K.',
  city: 'Bowling Green',
  state: 'KY'
}, {
  name: 'Patrick M.',
  city: 'Taos',
  state: 'NM'
}, {
  name: 'Courtney H.',
  city: 'Wilmington',
  state: 'NC'
}, {
  name: 'Sean D.',
  city: 'Provo',
  state: 'UT'
}, {
  name: 'Christina B.',
  city: 'Galveston',
  state: 'TX'
}, {
  name: 'Derek F.',
  city: 'Olympia',
  state: 'WA'
}, {
  name: 'Samantha C.',
  city: 'Ann Arbor',
  state: 'MI'
}, {
  name: 'Greg P.',
  city: 'Knoxville',
  state: 'TN'
}, {
  name: 'Vanessa N.',
  city: 'Napa',
  state: 'CA'
}, {
  name: 'Josh A.',
  city: 'Lawrence',
  state: 'KS'
}, {
  name: 'Tiffany G.',
  city: 'Key West',
  state: 'FL'
}];
function getRandomMinutesAgo(): string {
  const mins = Math.floor(Math.random() * 45) + 2;
  return `${mins} min ago`;
}
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const shuffledRef = useRef<number[]>([]);
  const idxRef = useRef(0);
  useEffect(() => {
    shuffledRef.current = [...Array(PURCHASES.length).keys()].sort(() => Math.random() - 0.5);
    const showNotification = () => {
      const idx = shuffledRef.current[idxRef.current % shuffledRef.current.length];
      setCurrentIndex(idx);
      setVisible(true);
      window.dispatchEvent(new CustomEvent('purchase-notification'));
      // Hide after 7 seconds
      setTimeout(() => {
        setVisible(false);
        idxRef.current += 1;
      }, 7000);
    };
    // First notification after 6 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 6000);
    // Then every 10-12 seconds show the next one
    const interval = setInterval(() => {
      showNotification();
    }, 11000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (dismissed) return null;
  const person = PURCHASES[currentIndex];
  return <AnimatePresence data-id="element-111">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 left-4 z-50 max-w-sm" data-id="element-112">
          <div className="bg-night-800 border border-gold-500/30 rounded-xl p-3.5 shadow-2xl shadow-black/40 flex items-start gap-3 relative" data-id="element-113">
            <button onClick={() => setDismissed(true)} className="absolute top-1.5 right-2.5 text-slate-600 hover:text-slate-400 text-xs leading-none focus:outline-none" aria-label="Dismiss" data-id="element-114">
              ✕
            </button>

            <img src={COVER_IMAGE} alt="The Taproot Protocol" className="w-14 h-14 rounded-lg object-cover flex-shrink-0 border border-white/10" data-id="element-115" />

            <div className="min-w-0 pr-4" data-id="element-116">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-117">
                <BadgeCheck className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-118" />
                <span className="text-green-500 text-xs font-semibold" data-id="element-119">
                  Verified Purchase
                </span>
              </div>
              <p className="text-white text-sm font-medium leading-tight" data-id="element-120">
                {person.name}
              </p>
              <p className="text-slate-300 text-xs mt-0.5" data-id="element-121">
                The Sleep Fix — The Taproot Protocol
              </p>
              <p className="text-slate-500 text-xs" data-id="element-122">
                {person.city}, {person.state} · {getRandomMinutesAgo()}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}